import { render, staticRenderFns } from "./ShashaPrivacyPolicy.vue?vue&type=template&id=52a4a14d&scoped=true&"
import script from "./ShashaPrivacyPolicy.vue?vue&type=script&lang=ts&"
export * from "./ShashaPrivacyPolicy.vue?vue&type=script&lang=ts&"
import style0 from "./ShashaPrivacyPolicy.vue?vue&type=style&index=0&id=52a4a14d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a4a14d",
  null
  
)

export default component.exports